export function RandomSpectrumTarget() {
  return Math.floor(Math.random() * 21);
}
